<template>
    <footer class="copyright-footer">
        <div class="copyright-container">
            <p>&copy; 2025 Example Company. All rights reserved.</p>
            <a href="https://beian.miit.gov.cn/" target="_blank"><p>陇ICP备2024009890号-1</p></a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62042202000161" target="_blank">
                <img src="@/assets/image/beian.png" class="beian-img">
                <p>甘公网安备 62042202000161号</p>
            </a>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppCopyright'
}
</script>

<style scoped>
.copyright-footer {
    background-color: #333;
    color: #fff;
    text-align: center;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 隐藏溢出内容 */
}

.copyright-container {
    display: inline-block;
    white-space: nowrap; /* 防止子元素换行 */
    padding: 15px 0;
}

.copyright-footer p,
.copyright-footer a {
    display: inline-block;
    float: none; /* 移除浮动 */
    height: 20px;
    line-height: 20px;
    margin: 0 5px; /* 调整间距 */
    color: #939393;
}

.beian-img {
    vertical-align: middle; /* 图片垂直居中 */
    margin-right: 5px;
}
</style>